import {React,useEffect,useState} from 'react'
import SongCard from '../../Cards/SpotifyArtistSongCard'
import {Link} from 'react-router-dom';
import useFetch from '../../APIs/SpotifyGetArtistSingles.js';
import LoadingSkeleton from '../../LoadingSkeletons/Card05.js';

import { Swiper, SwiperSlide } from "swiper/react";
// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";


// import required modules
import { Navigation } from "swiper/modules";

const TopSongs = (props) => {
 
    //userId,songId,search_string,genre,sort,page,
    
    const [data, setData] = useState(null);
    const [request, setRequest] = useState(null)
    const {data:FetchedData,isLoading, error} = useFetch(request)

    useEffect(()=>{
        if(FetchedData && FetchedData.total>0){
            setData(FetchedData)
            props.setTotalSingles(FetchedData.total)
        }
    },[FetchedData])


    const send_request =()=>{
        setData(null)
        setRequest({
            "user_id":props.filters.user_id,
            "song_id":"",
            "search_string":props.filters.search_string,
            "genre":props.filters.genre,
            "sort":props.filters.sort===""?"newest":props.filters.sort,
            "type":"",
            "page":"",
        })
    }



    useEffect(()=>{
        send_request()
    },[props.filters])

  return (
    <>
    
        
    {data &&(
        <>
            <section>
                <div className="row">
                    <div className="col-12 col-lg-12">

                
                        <div className="htitle">
                            <div className="lft"><p>Singles</p></div>
                            {data.total>10 &&(
                                <div className="rgt"><p><Link to={"/spotify/profile/browse/"+props.filters.user_id+"?group=songs"}>See more</Link></p></div>
                            )}
                        </div>
                        {props.innerWidth<992 &&(
                            <div className="vertical-container">
                                {data.items.map((song,index)=>{
                                        return <SongCard key={index} data = {song} Data = {data.results} index={index}/> 
                                    }
                                )}

                            </div>
                        )}
                        {props.innerWidth>992 &&(
                        <Swiper
                                navigation={true}
                                modules={[Navigation]}
                                breakpoints={{
                                    640: {
                                        slidesPerView: 2,
                                        spaceBetween: 10,
                                    },
                                    992: {
                                        slidesPerView: 5,
                                        spaceBetween: 20,
                                    },
                                    1600: {
                                        slidesPerView: 7,
                                        spaceBetween: 30,
                                    },
                                }}
                                className="mySwiper"
                            >
                                {data.items.map((song,index)=>{
                                        return <SwiperSlide key={index}><SongCard  data = {song} Data={data.results} index={index}/></SwiperSlide>
                                    }
                                )}
                            
                        </Swiper>           
                        )}
                    </div>
                </div>
            </section>
        </>
    )}
    {(isLoading) &&(
        <>
            <div className="htitle">
                <div className="lft"><p>Singles</p></div>
                <div className="rgt"><p><Link to={"/spotify/profile/browse/"+props.filters.user_id+"?group=songs"}>See more</Link></p></div>
            </div>
            {props.innerWidth<992 &&(
                <div className="vertical-container">
                    <LoadingSkeleton/>
                    <LoadingSkeleton/>
                    <LoadingSkeleton/>
                    <LoadingSkeleton/>
                    <LoadingSkeleton/>
                    <LoadingSkeleton/>
                </div>
            )}
            {props.innerWidth>992 &&(
                <Swiper
                    navigation={true}
                    modules={[Navigation]}
                    breakpoints={{
                        640: {
                            slidesPerView: 2,
                            spaceBetween: 10,
                        },
                        992: {
                            slidesPerView: 5,
                            spaceBetween: 20,
                        },
                        1600: {
                            slidesPerView: 7,
                            spaceBetween: 30,
                        },
                    }}
                    className="mySwiper"
                >
                    <SwiperSlide ><LoadingSkeleton/></SwiperSlide>
                    <SwiperSlide ><LoadingSkeleton/></SwiperSlide>
                    <SwiperSlide ><LoadingSkeleton/></SwiperSlide>
                    <SwiperSlide ><LoadingSkeleton/></SwiperSlide>
                    <SwiperSlide ><LoadingSkeleton/></SwiperSlide>
                    <SwiperSlide ><LoadingSkeleton/></SwiperSlide>
                    <SwiperSlide ><LoadingSkeleton/></SwiperSlide>
                    <SwiperSlide ><LoadingSkeleton/></SwiperSlide>
                    
                </Swiper>           
            )}
        </>
    )}
                
    </>
  )
}

export default TopSongs